// extracted by mini-css-extract-plugin
export default {"base":"vp_Sfg1s","inputWrapper":"vp_eVpab","button":"vp_zpMBf","noSpacing":"vp_eobIc","alignRight":"vp_auLi_"};